module.exports = __webpack_public_path__ + "img/stats_fr.d9f5439.webp";